import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import UniteProjet from '../Entity/UniteProjet'

/**
* Class UniteProjetList
* UniteProjetList view component
**/
class UniteProjetList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = UniteProjet;

    // Filter list
    const filters = [{
      title: "Nom du type de document",
      type: "text",
      name: "libelle",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes types de document</h2>
        <GridFilter title="Filtrer les types de document" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Types de document" ref={"grid" + objectClass.name} path="uniteprojets" objectPath="uniteprojets" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + UniteProjet.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + UniteProjet.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + UniteProjet.name];
    grid.clearFilters();
  }

}
export default UniteProjetList;



// WEBPACK FOOTER //
// ./src/views/Search/UniteProjetList.js